import { CLEAR_NOTIFICATION, NotificationActionTypes, NotificationState, SET_NOTIFICATION } from './types'

const initialState: NotificationState = {
  type: null,
  messages: null,
}

export function notificationsReducer(state = initialState, action: NotificationActionTypes): NotificationState {
  // Guard against entity actions for another type.  Non entity actions and entity actions for another type we must ignore.
  if (action.type !== SET_NOTIFICATION && action.type !== CLEAR_NOTIFICATION) {
    return state
  }

  switch (action.type) {
    case SET_NOTIFICATION: {
      return {
        ...state,
        type: action.payload.type,
        messages: action.payload.messages,
      }
    }
    case CLEAR_NOTIFICATION: {
      return {
        ...state,
        type: null,
        messages: null,
      }
    }
    default:
      return state
  }
}
